import React from 'react'
import {Button} from 'react-bootstrap'
import VerticalReading from '../../../../shared/components/VerticalReading'
import {VerticalDivider} from '../../../../shared/components'
import {VerticalDateTime} from '../../../../shared/components'

export interface Reading {
  readingId: number
  systolic: number
  diastolic: number
  pulse: number | null
  createdAt?: string
  status: string // e.g. 'Stage 2 Alert'
}

interface AlertCardProps {
  alert: Reading
  patientUUID: string
  onResolve: (readingId: number) => void
}

const localStatusColors: Record<string, string> = {
  Crisis: '#8b0000', // $custom-crisis
  'Stage 2': '#dc3545', // $custom-stage2
  'Stage 1': '#fd7e14', // $custom-stage1
  Elevated: '#ffc107', // $custom-elevated
  Low: '#2ecbf2', // $custom-low
  Default: '#6c757d', // $custom-secondary
}

const BPAlertCard: React.FC<AlertCardProps> = ({alert, patientUUID, onResolve}) => {
  const {readingId, systolic, diastolic, pulse, createdAt, status: raw} = alert

  // strip trailing "Alert"/"Alerts"
  const displayStatus = raw.replace(/Alerts?$/i, '').trim()

  // pick color or fallback
  const color = localStatusColors[displayStatus] || localStatusColors.Default
  const [loading, setLoading] = React.useState(false)

  const handleResolveClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setLoading(true)
    await onResolve(readingId)
    setLoading(false)
  }

  return (
    <div className='custom-card-outlined_1 p-3'>
      {/* header */}
      <div className='d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2'>
        <h5 className='fw-bold fs-5 fs-md-4' style={{color}}>
          {displayStatus}
        </h5>
        <Button
          variant='success'
          onClick={handleResolveClick}
          className='d-flex align-items-center gap-1 gap-md-2 px-2 px-md-3 py-1 rounded-3'
          size='sm'
          disabled={loading}
        >
          {loading ? (
            <>
              <span className='spinner-border spinner-border-sm me-1' aria-hidden='true'></span>
              <span className='text-white fw-bold'>Loading...</span>
            </>
          ) : (
            <span className='text-white fw-bold'>Mark as Reviewed</span>
          )}
        </Button>
      </div>

      {/* readings */}
      <div className='d-flex align-items-center justify-content-between'>
        <VerticalReading topValue={systolic} bottomValue={diastolic} bpmValue={pulse?.toString()} />
        <VerticalDivider />
        <VerticalDateTime datetime={createdAt || ''} />
      </div>
    </div>
  )
}

export default BPAlertCard
